import type { ChangeEvent } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

import { Input } from "./Input";
import { SelectList, SelectListItem } from "./Select";
import { Typography } from "./Typography";
import { IconTextButton } from "./IconTextButton";

library.add(faTimesCircle);

export type Products = {
  code: string;
  name: string;
  description: string;
};

type Props = {
  number: number;
  productCode: string | undefined;
  quantity: number | undefined;
  products: Products[];
  onProductCodeChange: (value: string | number, dataId: string | null) => void;
  onQuantityChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onDeleteRowClick: (dataId: number) => void;
};

type InputProps = {
  width?: string;
};

const InputWrapper = styled.div<InputProps>`
  width: ${(props) => props.width || "30%"};
  float: left;
  margin: 0 30px 5px 0;
`;

const InputGroupWrapper = styled.div`
  margin: 6px 0 10px 0;
  clear: both;
`;

const ButtonArea = styled.div`
  margin-left: auto;
  margin-top: 12px;
`;

export function ProductItem({
  number,
  productCode,
  quantity,
  products,
  onProductCodeChange,
  onQuantityChange,
  onDeleteRowClick,
}: Props) {
  return (
    <InputGroupWrapper key={number}>
      <InputWrapper width="70%">
        <SelectList
          key={number}
          dataId={number}
          placeholder={""}
          value={productCode}
          onValueChange={onProductCodeChange}
          items={products.map((product) => (
            <SelectListItem value={product.code} key={product.code}>
              <Typography size={2}>
                {`${product.name} : ${product.description}`}
              </Typography>
            </SelectListItem>
          ))}
        />
      </InputWrapper>
      <InputWrapper width="8%">
        <Input
          dataId={number.toString()}
          value={quantity?.toString()}
          number={true}
          onChange={onQuantityChange}
          suffix={"個"}
        />
      </InputWrapper>
      <InputWrapper width="10%">
        <ButtonArea>
          <IconTextButton
            icon={<FontAwesomeIcon icon={"times-circle"} />}
            onButtonClick={() => {
              onDeleteRowClick(number);
            }}
          />
        </ButtonArea>
      </InputWrapper>
    </InputGroupWrapper>
  );
}
